<template>
  <v-navigation-drawer
    temporary
    stateless
    fixed
    right
    v-model="drawer"
    touchless
    style="top: 48px;"
    :width="500"
    role="complementary">
    <template v-if="drawer">
      <v-toolbar flat style="position: sticky; top: 0; z-index: 30" role="navigation">
        <v-list>
          <v-list-tile>
            <v-btn flat icon @click="cancelClicked" class="back-button">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-list-tile-title class="title">
              {{$t('admin.alerts.alerts')}}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <div style="padding-bottom: 50px">
        <div class="pl-3 pt-3">
          <h2 class="mb-1">{{alert.name}}</h2>
          <tree-node :tree="tree" v-bind="{openNode, tickNode}"></tree-node>
        </div>

        <v-layout row justify-center mt-3>
          <v-btn @click="cancelClicked">
            {{$t('cancel')}}
          </v-btn>
          <v-btn @click="applyClicked" color="primary" :disabled="!changedTree">
            {{$t('apply')}}
          </v-btn>
        </v-layout>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import {SET_ALERT_HIERARCHY_DRAWER_STATE, SET_CLASS_HIERARCHY_OPEN, SET_CLASS_HIERARCHY_TICK} from '../store/mutation-types'
import {SAVE_ADMIN_ALERT_HIERARCHY} from '../store/action-types'
import {GET_ALERT, GET_HIERARCHY_CLASS_IDS} from '../store/getter-types'
import TreeNode from './tree/TreeNode'

export default {
  name: 'tree-drawer',
  methods: {
    applyClicked () {
      let data = {hierarchyClassIds: this.hierarchyClassIds, alertId: this.alert.id}
      this.saveAdminHierarchy(data)
    },
    cancelClicked () {
      this.drawer = false
    },
    openNode (id, expanded) {
      this.openTreeNode({id, expanded})
    },
    tickNode (id, ticked) {
      this.tickTreeNode({id, ticked})
    },
    ...mapMutations({
      openTreeNode: SET_CLASS_HIERARCHY_OPEN,
      tickTreeNode: SET_CLASS_HIERARCHY_TICK
    }),
    ...mapActions({
      saveAdminHierarchy: SAVE_ADMIN_ALERT_HIERARCHY
    })
  },
  computed: {
    ...mapState({
      tree: state => state.hierarchy.tree,
      changedTree: state => state.hierarchy.changedTree
    }),
    ...mapGetters({
      alert: GET_ALERT,
      hierarchyClassIds: GET_HIERARCHY_CLASS_IDS
    }),
    drawer: {
      get () {
        return this.$store.state.admin.alertHierarchyDrawer
      },
      set (state) {
        this.$store.commit(SET_ALERT_HIERARCHY_DRAWER_STATE, state)
      }
    }
  },
  components: {
    TreeNode
  }
}
</script>

<style scoped>
.back-button {
  position: absolute;
  left: 0;
  top: 0;
}
.title {
  margin-left: 35px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/TreeDrawer.vue